export const paramLegendTitles=[
    {"id":"forets_type_peuplement","nom":"Etat - Feuillus / résineux"},
    {"id":"forets_essence","nom":"Etat - Essences"},
    {"id":"forets_forme_tronc","nom":"Etat - Forme du tronc"},
    {"id":"forets_bois_oeuvre","nom":"Potentiel - Bois d'oeuvre"},
    {"id":"forets_exposable_humidite","nom":"Potentiel - Usage en extérieur"},
    {"id":"cultures_description","nom":"Etat - cultures à matières"},
    {"id":"cultures_matiere","nom":"Potentiel - module matières"},
    {"id":"cultures_materiau","nom":"Potentiel - module matériaux"},
    {"id":"carrieres_statut","nom":"Autorisation d'exploiter"},
    {"id":"carrieres_substrat_principal","nom":"Matériau principal"}
]